import styled from 'styled-components';
import { COLORS, DEVICES } from '@/theme';

export const StyledContentWrapper = styled.div`
  background: ${COLORS.WHITE};
  border: none;
  border-radius: 0;
  padding: 0;
  text-align: left;

  @media screen and ${DEVICES.LAPTOP_S} {
    background: ${COLORS.WHITE};
    border: 1px solid ${COLORS.BRIGHT_GRAY};
    border-radius: 0.5rem;
    padding: 1rem 1.5rem;
  }
`;

export const StyledInfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 0;
  border-bottom: 1px solid ${COLORS.BRIGHT_GRAY};

  @media screen and ${DEVICES.LAPTOP_S} {
    padding: 0;
  }
`;
